import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { EntityProfileType, EntityProfileTypes } from '@rma/generic/domain/types';

export const entityProfileTypeGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const type = segments[0]?.path;
  return Object.values(EntityProfileTypes).includes(type as EntityProfileType);
};
